// components/handleLogin.js
import { baseBackendURL } from "../helpers/baseUrl";

export const handleLogin = async (
  e,
  {
    email,
    password,
    captchaToken,
    setError,
    setSuccessMessage,
    setOverlayContent,
  }
) => {
  e.preventDefault();
  setSuccessMessage("");
  setError("");
  try {
    const response = await fetch(`${baseBackendURL}/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password, captchaToken }),
      credentials: "include",
    });
    const data = await response.json();
    if (data.success) {
      window.location.href = "/app";
    } else {
      setError(data.message || "Invalid email or password");
    }
    if (data.show_intro) {
      setOverlayContent("intro");
    }
  } catch (error) {
    console.error("Error logging in:", error);
    setError("Unable to reach server. Please try again later.");
  }
};
